module.exports = __webpack_public_path__ + "static/media/rightbf.b4d5fac5.png";